import { render, staticRenderFns } from "./CharacteristicList.vue?vue&type=template&id=0bbc6c54"
import script from "./CharacteristicList.vue?vue&type=script&lang=js"
export * from "./CharacteristicList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports